import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { ExcelInventoryImport_ModuleContextService } from './ExcelInventoryImport.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class ExcelInventoryImport_excel_inventory_import_grid_ComponentContextService {
  private readonly moduleContext: ExcelInventoryImport_ModuleContextService;

  constructor(moduleContext: ExcelInventoryImport_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'excel_inventory_import_grid',
      type: ComponentType.grid
    }
  }
}